import { createAppAsyncThunk } from "core/src/store/store.types";

export type UpdateLocationRequest = {
	pathname: string;
}

type UpdateLocationResponse = {
	pathname: string;
}

export const updateLocation = createAppAsyncThunk<UpdateLocationResponse, UpdateLocationRequest>(
	"navigation/updateLocation",
	async ({ pathname }) => {
		return { pathname };
	}
);
